import * as yup from 'yup';

export const buyersCreateStep1Schema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    name: yup
      .string()
      .required(t('buyers.create.errors.missing.name'))
      .max(255, t('buyers.create.errors.inputTooLong', { maxLength: '255' })),
    postalCode: yup
      .string()
      .required(t('buyers.create.errors.missing.postalCode'))
      .max(255, t('buyers.create.errors.inputTooLong', { maxLength: '255' })),
    city: yup
      .string()
      .required(t('buyers.create.errors.missing.city'))
      .max(255, t('buyers.create.errors.inputTooLong', { maxLength: '255' })),
    addressLine: yup
      .string()
      .nullable()
      .max(255, t('buyers.create.errors.inputTooLong', { maxLength: '255' })),
    phoneNumber: yup
      .string()
      .nullable()
      .max(12, t('buyers.create.errors.inputTooLong', { maxLength: '12' })),
  });
